import createUseStyles from '@eduzz/houston-styles/createUseStyles';

export const useStyles = createUseStyles((theme) => ({
  productTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  root: {
    '& .title': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#596375',
      paddingRight: '1rem',
    },

    '& .charger-type': {
      width: 15,
    },

    '& .table-row': {
      cursor: 'pointer',
    },

    '& .moderation__status': {
      fontWeight: 600,
      fontSize: '0.85rem',
    },

    '& .-moderation, .-pending': {
      color: '#4159AD',
    },

    '& .-approved': {
      color: '#009358',
    },

    '& .-disapproved': {
      color: '#dc3f53',
    },

    '& .product__cell': {
      display: 'flex',
      justifyContent: 'left',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },

    '& .image': {
      width: '50px',
      height: '50px',
      border: '1px solid #eee',
      borderRadius: '3px',
      display: 'flex',
      backgroundSize: 'cover',
      backgroundRepeat: 'noRepeat',
      backgroundPosition: 'center',
      backgroundColor: '#eee',
      marginRight: '12px',
    },

    '& .price': {
      '& .value': {
        fontWeight: 400,
        fontSize: '0.875rem',
        color: '#009358',
      },

      '& .commission': {
        display: 'block',
        fontSize: '0.875rem',
        letterSpacing: '0.02rem',
        marginTop: '0.2rem',
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
        color: '#596375',
      },

      '& .view__children': {
        fontSize: '0.875rem',
      },
    },

    '& .--active': {
      fontSize: '0.875rem',
      color: '#009358',
      fontWeight: 600,
    },

    '& .--inactive': {
      fontSize: '0.875rem',
      fontWeight: 600,
    },
  },
}));
